import { render, staticRenderFns } from "./ObligationDelete.vue?vue&type=template&id=71168b48"
import script from "./ObligationDelete.vue?vue&type=script&lang=js"
export * from "./ObligationDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports